module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tr-user",
    class: {
      'tr-user--cant-edit': !_vm.theUserCanManageAssignedHours || _vm.isPoolsDeactivated
    }
  }, [_c('th', {
    staticClass: "tr-user__name"
  }, [_c('div', {
    staticClass: "tr-user__name__inner"
  }, [_c('p', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
    staticClass: "tr-user__name__bttn icon__bg-circle hint--right",
    attrs: {
      "aria-label": _vm.$t('vue2.task_overview.task_overview')
    },
    on: {
      "click": _vm.setTheActiveUserInAssignHours
    }
  }, [_c('svg', {
    staticClass: "icon-chart tw-icon tw-icon--small",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "secondary",
    attrs: {
      "d": "M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
    }
  })])])])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window',
        onShow: function () { return !_vm.isDatesPristine; }
      }),
      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => !isDatesPristine\n            }"
    }],
    staticClass: "number number_edit td-presence",
    class: {
      'is-number--calculated': !_vm.isDatesPristine
    },
    attrs: {
      "content": _vm.createTooltip(_vm.user.assigned_total_hours)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openEdit(_vm.user.assigned_total_hours, 'assigned_total_hours', $event)
      }
    }
  }, [(!_vm.isDatesPristine) ? _c('span', {
    staticClass: "icon-clock"
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.user.v_total_hours_assigned_in_period) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "number td-presence",
    attrs: {
      "aria-label": _vm.user.actual_total_hours
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
    staticClass: "number td-presence number__scale-indicator",
    style: (_vm.scaleIndicator(_vm.user.diff_total_hours)),
    attrs: {
      "aria-label": _vm.user.diff_total_hours
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPoolsDeactivated) ? _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        content: ("<div>\n                <div class='do-flex-labels'>Arbejdstid: <span>" + (_vm.user.assigned_total_hours) + "</span></div>\n                <div class='do-flex-labels'>Tildelte timer: <span>" + (_vm.user.sum_hours) + "</span></div>\n              </div>"),
        allowHTML: true,
        arrow: true,
        placement: 'left'
      }),
      expression: "{\n    content: `<div>\n                <div class='do-flex-labels'>Arbejdstid: <span>${user.assigned_total_hours}</span></div>\n                <div class='do-flex-labels'>Tildelte timer: <span>${user.sum_hours}</span></div>\n              </div>`,\n    allowHTML: true,\n    arrow: true,\n    placement: 'left'\n  }"
    }],
    staticClass: "number pointer td-rest number__scale-indicator",
    style: (_vm.scaleIndicator(_vm.user.rest_hours)),
    attrs: {
      "aria-label": _vm.user.rest_hours
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
    staticClass: "number number_edit td-teaching",
    attrs: {
      "aria-label": _vm.user.assigned_teaching_hours
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openEdit(_vm.user.assigned_teaching_hours, 'assigned_teaching_hours', $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "number td-teaching",
    attrs: {
      "aria-label": _vm.user.actual_teaching_hours
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
    staticClass: "number number__scale-indicator td-teaching",
    style: (_vm.scaleIndicator(_vm.user.diff_teaching_hours)),
    attrs: {
      "aria-label": _vm.user.diff_teaching_hours
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
    staticClass: "number number_edit td-tasks",
    attrs: {
      "aria-label": _vm.user.assigned_additional_task_hours
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openEdit(_vm.user.assigned_additional_task_hours, 'assigned_additional_task_hours', $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "number td-tasks",
    attrs: {
      "aria-label": _vm.user.actual_additional_task_hours
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
    staticClass: "number number__scale-indicator td-tasks",
    style: (_vm.scaleIndicator(_vm.user.diff_additional_task_hours)),
    attrs: {
      "aria-label": _vm.user.diff_additional_task_hours
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        content: ((_vm.user.assigned_teaching_hours) + " UV-timer * " + _vm.prepFactor + " forberedelsesfaktor"),
        arrow: true,
        placement: 'top',
        onShow: function () { return _vm.isShowPrepFactorCalculation; }
      }),
      expression: "{\n    content: `${user.assigned_teaching_hours} UV-timer * ${prepFactor} forberedelsesfaktor`,\n    arrow: true,\n    placement: 'top',\n    onShow: () => isShowPrepFactorCalculation\n  }"
    }],
    staticClass: "number number_edit td-preparation",
    attrs: {
      "aria-label": _vm.user.assigned_preparation_hours
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openEdit(_vm.user.assigned_preparation_hours, 'assigned_preparation_hours', $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "number td-preparation",
    attrs: {
      "aria-label": _vm.user.actual_preparation_hours
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
    staticClass: "number number__scale-indicator td-preparation",
    style: (_vm.scaleIndicator(_vm.user.diff_preparation_hours)),
    attrs: {
      "aria-label": _vm.user.diff_preparation_hours
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isLocalPoolActivated) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
    staticClass: "number number_edit td-preparation",
    attrs: {
      "aria-label": _vm.user.assigned_pool_hours
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openEdit(_vm.user.assigned_pool_hours, 'assigned_pool_hours', $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "number td-preparation",
    attrs: {
      "aria-label": _vm.user.actual_pool_hours
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
    staticClass: "number number__scale-indicator td-preparation",
    style: (_vm.scaleIndicator(_vm.user.diff_pool_hours)),
    attrs: {
      "aria-label": _vm.user.diff_pool_hours
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "number pointer td-absence",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setActiveUser('absence')
      }
    }
  }, [_c('div', {
    staticClass: "tr-user__text"
  }, [_vm._v("\n      " + _vm._s(_vm.user.actual_absence_hours) + "\n    ")])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
    staticClass: "number number_edit td-sub-hours",
    attrs: {
      "aria-label": _vm.user.substitute_pool_hours
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openEdit(_vm.user.substitute_pool_hours, 'substitute_pool_hours', $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "number pointer td-sub-hours",
    attrs: {
      "aria-label": _vm.user.actual_substitute_hours
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setActiveUser('substituteHours')
      }
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
    staticClass: "number number__scale-indicator td-sub-hours",
    style: (_vm.scaleIndicator(_vm.user.diff_substitute_hours)),
    attrs: {
      "aria-label": _vm.user.diff_substitute_hours
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSFOActive) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
    staticClass: "number number_edit td-club",
    attrs: {
      "aria-label": _vm.user.assigned_club_hours
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openEdit(_vm.user.assigned_club_hours, 'assigned_club_hours', $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "number td-club",
    attrs: {
      "aria-label": _vm.user.actual_club_hours
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
    staticClass: "number number__scale-indicator td-club",
    style: (_vm.scaleIndicator(_vm.user.diff_club_hours)),
    attrs: {
      "aria-label": _vm.user.diff_club_hours
    }
  }) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f76bb71a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AssingHoursAllUsersUserPerf.vue
// module id = 1782
// module chunks = 1